import {
  Datagrid,
  EditButton,
  FunctionField,
  List,
  TextField,
} from 'react-admin'
import { CardContent, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

const ListCurves = (props) => {
  return (
    <CardContent>
      <Typography typography="h4" component="h1" mb={2}>
        Curves
      </Typography>
      <List title="Curves">
        <Datagrid>
          <TextField label="Name" source="name" />
          <TextField label="Applies To" source="appliesTo" />
          <TextField label="Active From" source="active_from" />
          <TextField label="Active To" source="active_until" />
          <FunctionField
            label="Active"
            render={(record) => {
              if (record.active) {
                return <CheckIcon />
              } else {
                return <CloseIcon />
              }
            }}
          />
          <EditButton {...props} />
        </Datagrid>
      </List>
    </CardContent>
  )
}

export default ListCurves
